import _ from "lodash";

import { IOption } from "model/application/components";
import TLang from "model/application/Lang";

export function getWeeksOptions(lang: TLang): IOption[] {
  const label = lang.containers.clients.subCategories.clients.createEditModal;
  return _.sortBy(
    [
      {
        key: "mo",
        value: 1,
        label: label.inputTrackingDays.options.mo,
      },
      {
        key: "tu",
        value: 2,
        label: label.inputTrackingDays.options.tu,
      },
      {
        key: "we",
        value: 3,
        label: label.inputTrackingDays.options.we,
      },
      {
        key: "th",
        value: 4,
        label: label.inputTrackingDays.options.th,
      },
      {
        key: "fr",
        value: 5,
        label: label.inputTrackingDays.options.fr,
      },
      {
        key: "sa",
        value: 6,
        label: label.inputTrackingDays.options.sa,
      },
      {
        key: "su",
        value: 7,
        label: label.inputTrackingDays.options.su,
      },
    ],
    "value",
  );
}
